import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { DynamicLabelService } from '../services/school/dynamic-label.service';

@Pipe({
  name: 'dynamicLabel'
})
export class DynamicLabelPipe implements PipeTransform {
  constructor(private dynamicLabelService: DynamicLabelService) {}

  transform(value: string): Observable<string> {
    if (!value) {
      return new Observable(observer => observer.next(''));
    }

    switch (value.toLowerCase()) {
      case 'subject':
      case 'course':
        return this.dynamicLabelService.subjectLabel;
      case 'student':
      case 'learner':
        return this.dynamicLabelService.studentLabel;
      case 'evaluation':
      case 'assessment':
        return this.dynamicLabelService.evaluationLabel;
      case 'term':
        return this.dynamicLabelService.termLabel;
      case 'semester':
        return this.dynamicLabelService.semesterLabel;
      case 'courseregistration':
        return this.dynamicLabelService.courseRegistrationLabel;
      case 'studentregistration':
        return this.dynamicLabelService.studentRegistrationLabel;
      case 'academiclevel':
        return this.dynamicLabelService.academicLevelLabel;
      case 'sequence':
        return this.dynamicLabelService.sequenceLabel;
      case 'department':
        return this.dynamicLabelService.departmentLabel;
      case 'specialization':
        return this.dynamicLabelService.specializationLabel;
      default:
        console.warn(`DynamicLabelPipe: Unknown label key: ${value}`);
        return this.dynamicLabelService.subjectLabel; // fallback
    }
  }
}
